module.exports = __webpack_public_path__ + "media/images/guide-9-3ca5b78e23522bc945ddf9444c0a6043.png";